var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vb-set" },
    [
      _c("transition", { attrs: { name: "vb-transition" } }, [
        _vm.maximizedBalloon
          ? _c(
              "div",
              { ref: "maximized", staticClass: "vb-set-maximized" },
              [
                _c(
                  "balloon",
                  _vm._b(
                    {
                      key: _vm.maximizedBalloon.key,
                      attrs: {
                        balloonState: _vm.balloonState,
                        balloon: _vm.maximizedBalloon,
                        position: null
                      }
                    },
                    "balloon",
                    _vm.maximizedBalloon,
                    false
                  ),
                  [_vm._t("default", null, null, _vm.maximizedBalloon)],
                  2
                )
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.classes },
        _vm._l(_vm.balloons, function(balloon) {
          return _c(
            "balloon",
            _vm._g(
              _vm._b(
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        balloon !== _vm.maximizedBalloon ||
                        _vm.dockKeepMaximized,
                      expression:
                        "balloon !== maximizedBalloon || dockKeepMaximized"
                    }
                  ],
                  key: balloon.key,
                  staticClass: "vb-multiple",
                  attrs: {
                    balloonState: _vm.balloonState,
                    balloon: balloon,
                    position: null,
                    "force-minimized": true
                  }
                },
                "balloon",
                balloon,
                false
              ),
              balloon.on
            ),
            [_vm._t("default", null, null, balloon)],
            2
          )
        })
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-21950e7c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21950e7c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BalloonSet.vue
// module id = Rzeg
// module chunks = 0